export default {
  constructionDocuments: 'Construction Documents',
  objects: 'objects',
  name: 'Name',
  modified: 'Modified',
  size: 'Size',
  loading: 'Loading...',
  errorMessages: {
    unknownError: 'Something went wrong. Refresh the page!',
    noFilesFound: 'No files or folders found for this project.',
    chooseProjectIfs: 'Choose project IFS to open documents.',
    emptyFolder: 'Empty folder',
  },
  downloadFileConfirmationModal: {
    title: 'Download file',
    body: 'Are you sure that you want to dowload the following file?',
    cancel: 'Cancel',
    proceed: 'Download',
  },
  toast: {
    errorReload: 'Reload page and try again!',
  },
  sharepointExport: {
    sharepointExport: 'Sharepoint Export',
    exportAllReady: 'Export all ready',
    refreshHcs: 'Sync HCs',
    refresh: 'Refresh',
    help: 'Help',
    table: {
      columns: {
        reportType: 'Report type',
        totalAmount: 'Total amount',
        readyToExport: 'Unexported',
        status: 'Status',
        inProgress: 'In queue',
        exported: 'Exported',
        failed: 'Failed (unexported)',
      },
      reportType: {
        CABINET: 'Cabinet',
        WORK_VARIATION: 'Change Order Request',
        HUB: 'HUB',
        HC: 'HC',
        HP: 'HP',
        LAND_AGREEMENT: 'Land Agreement',
        LAND_SURVEY: 'Land Survey',
        SITE: 'Site',
        SPAN: 'Spans',
        MANHOLE: 'Well',
        MDU_BUILDING: 'Building',
        MDU_DELIVERY_POINT: 'Delivery points',
      },
      status: {
        NONE: ' ',
        READY: 'Ready',
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In progress',
      },
      exportButton: {
        EXPORTING: 'Exporting',
        NOT_READY: 'Export',
        SOME_READY: 'Export',
        ALL_COMPLETED: 'Export',
        ALL_READY: 'Export',
      },
    },
    helpModal: {
      title: 'Sharepoint Export',
      intro: {
        title: 'Export to Sharepoint from DeliveryPortal',
        body: 'Export completed reports as PDFs from DeliveryPortal to Sharepoint.',
      },
      howItWorks: {
        title: 'How it works',
        body: 'You can only export completed reports (see below). The reports are categorized by type, and you can track the export status in the table. When you export reports, it runs in the background. You can close DeliveryPortal and return later to check the results. Click "Refresh" to update the table – export details do not update automatically.',
      },
      exportableReportsCompleted: {
        title: 'Exportable reports (completed)',
        body: 'Each report has a specific "definition of done" that outlines what needs to be completed to start the export. Check the explanations for each report type.',
        reportType: {
          HP: 'HP - House passed',
          HC: 'HC - House connected',
          CABINET: 'Cabinet / FOS',
          MANHOLE: 'Well / Manhole',
          HUB: 'HUB',
          SITE: 'Site',
          SPAN: 'Spans',
        },
        dod: {
          STATUS_DONE: 'Has status Done',
          STATUS_RESTORED: 'Has status Restored',
          FILLED_AND_PERFORMED:
            'All executed dates filled in and all required self-inspections performed',
        },
      },
      tableDetails: {
        title: 'Table details',
        totalAmount: 'Total amount',
        totalAmountInfo: 'Amount of reports of the type in the project',
        unexported: 'Unexported',
        unexportedInfo: 'Amount of completed reports that can be exported',
        status: 'Status',
        statusInfo: 'Export status (Ready, In progress, Completed)',
        other: 'In queue / Exported / Failed',
        otherInfo: 'Amount of exported reports',
      },
      statusForExport: {
        title: 'Status for export',
        READY: 'Ready',
        READYInfo: 'Reports of the type are ready to be exported',
        IN_PROGRESS: 'In progress',
        IN_PROGRESSInfo: 'Export is running in the background',
        COMPLETED: 'Completed',
        COMPLETEDInfo: 'All reports exported successfully',
        NONE: '(empty)',
        NONEInfo:
          'Not all reports for the type are ready, but export can still be initiated',
      },
    },
    overwriteReportsConfirmationModal: {
      title: 'Reports will be overwritten',
      confirm: 'Confirm export',
      cancel: 'Cancel',
      body: 'The reports that have already been exported to Sharepoint will be overwritten',
    },
    loading: {
      pleaseWait: 'Loading page. Please wait...',
    },
    error: 'Something went wrong. Try again!',
    alerts: {
      exportStarted: 'Export started',
      exportFailed: 'Could not start exporting. Try again.',
      refreshSuccess: 'HC sync succeeded.',
      refreshFailed: 'HC sync failed.',
    },
  },
};
